import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

import type { DomainItem } from '@/entities/domain';

type UpdateDomainRequest = {
  domainId: string;
  operations: JsonPatchOperation[];
};

export const updateDomainApi = async (request: UpdateDomainRequest): Promise<DomainItem> => {
  const { domainId, operations } = request;
  const { data } = await openMetadataApiClient.patch<DomainItem>(`/domains/${domainId}`, operations, {
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
  });
  return data;
};

export type { UpdateDomainRequest };
